const createImage = url => new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', error => reject(error));
    image.src = url;
});

/**
 * Recorta `imageSrc` na região `pixelCrop` (em pixels da imagem original, como
 * o react-easy-crop devolve) e reencoda em um quadrado `size`×`size`.
 *
 * Como o recorte é 1:1, o resultado sai sempre quadrado e pequeno — isso mantém
 * o Data URL enviado ao backend leve, evitando estourar o `post_max_size` do PHP.
 *
 * @param {string} imageSrc  Data URL da imagem original.
 * @param {{x:number,y:number,width:number,height:number}} pixelCrop
 * @param {{size?:number,type?:string,quality?:number}} options
 * @returns {Promise<string>} Data URL (base64) da imagem recortada.
 */
export const getCroppedImg = async (imageSrc, pixelCrop, { size = 512, type = 'image/jpeg', quality = 0.9 } = {}) => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (!ctx) throw new Error('Canvas não suportado neste navegador.');

    canvas.width = size;
    canvas.height = size;

    // JPEG não tem canal alpha: sem este fundo branco, áreas transparentes
    // (PNG/GIF) sairiam pretas.
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, size, size);

    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';

    ctx.drawImage(
        image,
        pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height,
        0, 0, size, size
    );

    return canvas.toDataURL(type, quality);
};

export default getCroppedImg;
